// extracted by mini-css-extract-plugin
module.exports = {"filters":"DebtorReports_filters__1_VPn"};